/* Little Ounce: поиск посылки через приложение 17TRACK. Перенесено с Ebbrest (assets/eb-track.js) 20.10.2026, разметка в sections/lo-track.liquid. */
/*
  Ebbrest: поиск посылки на странице Track Order (sections/eb-track.liquid, решение 14.10.2026, Ilia).
  Данные даёт приложение 17TRACK, установленное в магазине; его названия покупатель не видит, статус рисуется здесь.
  Образец поведения: страницы трекинга на сайтах Роки (roki/SITES-TERMS-2026-10-13.md); код свой.

  Два запроса:
    1. shopify.17track.net/trackcenterapi/call: по трек-номеру (get-track-record-by-track-no) или по номеру заказа и почте
       (get-track-record-by-order-no). В ответе состав заказа и список посылок. Магазин называется короткой ручкой
       (wf15nm-2b), полный домен приложение не принимает. Неверная почта и несуществующий заказ дают одинаковый пустой ответ.
    2. shopify-t.17track.net/track/shopify: история сканов по одной посылке. code 100 значит «ещё собираю», спросить снова с guid.
  Посылка без ярлыка приходит номером вида notShipped-... или vpShipped-...
  Без скрипта форма не видна (hidden снимает скрипт), страница остаётся с прежними текстами.
*/
(function () {
  var root = document.querySelector('[data-lo-tracker]');
  if (!root) return;
  var API_INFO = 'https://shopify.17track.net/trackcenterapi/call',
    API_EVENTS = 'https://shopify-t.17track.net/track/shopify',
    SHOP = root.getAttribute('data-shop') || '',
    MAIL = root.getAttribute('data-mail') || '',
    form = root.querySelector('[data-lo-tr-form]'),
    input = root.querySelector('[data-lo-tr-num]'),
    label = root.querySelector('[data-lo-tr-label]'),
    emailRow = root.querySelector('[data-lo-tr-email-row]'),
    email = root.querySelector('[data-lo-tr-email]'),
    btn = root.querySelector('[data-lo-tr-btn]'),
    swap = root.querySelector('[data-lo-tr-swap]'),
    err = root.querySelector('[data-lo-tr-err]'),
    out = root.querySelector('[data-lo-tr-out]');
  if (!SHOP || !form || !input || !btn || !out) return;
  root.hidden = false;

  var STAGES = ['Ordered', 'Picked up', 'In transit', 'Out for delivery', 'Delivered'],
    MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    SUBS = {
      InfoReceived: 'Shipment information received',
      InTransit_PickedUp: 'Picked up by the courier',
      InTransit_Departure: 'Departed origin',
      InTransit_Arrival: 'Arrived at hub',
      InTransit_TransportDeparted: 'Departed facility',
      InTransit_TransportArrived: 'Arrived at facility',
      InTransit_CustomsProcessing: 'Customs processing',
      InTransit_CustomsReleased: 'Released by customs',
      InTransit_CustomsRequiringInformation: 'Customs needs information',
      InTransit_Other: 'In transit',
      OutForDelivery: 'Out for delivery',
      OutForDelivery_Other: 'Out for delivery',
      AvailableForPickup: 'Ready for pickup',
      AvailableForPickup_Other: 'Ready for pickup',
      Delivered: 'Delivered',
      Delivered_Other: 'Delivered',
      DeliveryFailure_NoBody: 'Delivery attempted, nobody home',
      DeliveryFailure_Rejected: 'Delivery refused',
      DeliveryFailure_InvalidAddress: 'Address needs attention',
      DeliveryFailure_Security: 'Held for a security check',
      DeliveryFailure_Other: 'Delivery attempt unsuccessful',
      Exception_Returning: 'Returning to sender',
      Exception_Returned: 'Returned to sender',
      Exception_Damage: 'Reported damaged in transit',
      Exception_Delayed: 'Delayed in transit',
      Exception_Lost: 'Reported lost by the courier',
      Exception_Other: 'Needs attention',
      NotFound_Other: 'Waiting for the first scan',
      NotFound_InvalidCode: 'Waiting for the first scan'
    },
    mode = 'order', seq = 0, busy = false, packs = [];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function mailHtml() {
    return MAIL ? '<a href="mailto:' + esc(MAIL) + '">' + esc(MAIL) + '</a>' : 'us through the <a href="/pages/contact">Contact page</a>';
  }
  function contactTail() { return MAIL ? ', or write to ' + MAIL + '.' : ', or reach us through the Contact page.'; }
  // старый результат под новой ошибкой не оставляем
  function showErr(text) { err.textContent = text; err.hidden = false; out.hidden = true; out.innerHTML = ''; }
  function clearErr() { err.textContent = ''; err.hidden = true; }
  function tz() { return new Date().getTimezoneOffset(); }
  // описание скана на китайском покупателю не показываем: вместо него подпись по коду статуса
  // и строки, где латиницей названо место отправки: вместо них тоже подпись по коду статуса
  function hasCJK(s) { s = String(s || ''); return /[^\u0000-\u024f\u2000-\u206f]/.test(s) || /\b(china|cn|prc|shenzhen|guangdong|guangzhou|dongguan|yiwu|hangzhou|shanghai|ningbo|xiamen|fujian|zhejiang|jiangsu|hong ?kong|hk)\b/i.test(s); }
  function subLabel(sub, status) {
    if (sub && SUBS[sub]) return SUBS[sub];
    var s = String(sub || status || 'Update').split('_').pop().replace(/([a-z])([A-Z])/g, '$1 $2');
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }
  function when(e) {
    var raw = (e && e.time_raw) || {};
    if (typeof raw.date === 'string' && raw.date) {
      var p = raw.date.split('-');
      return { d: MONTHS[(+p[1] || 1) - 1] + ' ' + (+p[2] || ''), t: String(raw.time || '').slice(0, 5) };
    }
    var iso = String((e && (e.time_iso || e.time_utc)) || '');
    if (iso.length < 10) return { d: '', t: '' };
    return { d: MONTHS[(+iso.slice(5, 7) || 1) - 1] + ' ' + +iso.slice(8, 10), t: iso.slice(11, 16) };
  }
  // запрос обрывается через 12 с: без этого при молчащем API кнопка оставалась заблокированной навсегда
  function post(url, body) {
    var ctl = window.AbortController ? new AbortController() : null,
      timer = ctl ? setTimeout(function () { ctl.abort(); }, 12000) : 0;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(timer); if (!r.ok) throw new Error('http'); return r.json(); }, function (e) { clearTimeout(timer); throw e; });
  }
  function call(method, param) {
    return post(API_INFO, { Version: '1.0', Method: method, SourceType: '0', Cookies: '', TimeZoneOffset: tz(), Param: param });
  }
  function placeholder(n) { return /^(notShipped|vpShipped)-/.test(n || ''); }
  function trackable(n) { return !!n && !placeholder(n); }
  function cleanNo(n) { n = String(n || ''); return n.indexOf('/') > -1 ? n.split('/')[1] : n; }

  function stageIndex(status, events) {
    if (status === 'Delivered') return 4;
    if (status === 'OutForDelivery' || status === 'AvailableForPickup') return 3;
    if (status === 'InTransit') return 2;
    if (status && (status.indexOf('DeliveryFailure') === 0 || status.indexOf('Exception') === 0)) return 2;
    for (var i = 0; events && i < events.length; i++) if (/^InTransit/.test(String(events[i].stage || events[i].sub_status || ''))) return 1;
    return 0;
  }
  function headline(status, metrics) {
    if (status === 'Delivered') return { h: 'Delivered', pill: 'Delivered', cls: 'done' };
    if (status === 'OutForDelivery') return { h: 'Out for delivery', pill: 'Almost there', cls: '' };
    if (status === 'AvailableForPickup') return { h: 'Ready for pickup', pill: 'Ready', cls: '' };
    if (status === 'InTransit') {
      var d = metrics && metrics.days_of_transit;
      return { h: 'On its way', pill: d ? 'Day ' + d + ' in transit' : 'In transit', cls: '' };
    }
    if (status && status.indexOf('DeliveryFailure') === 0) return { h: 'Delivery needs attention', pill: 'Action needed', cls: 'warn' };
    if (status && status.indexOf('Exception') === 0) return { h: 'Shipment needs attention', pill: 'Action needed', cls: 'warn' };
    return { h: 'Waiting for the first scan', pill: 'Getting ready', cls: 'wait' };
  }
  function itemsHtml(info) {
    var list = (info && info.pinfos) || [];
    if (!list.length) return '';
    var html = '<ul class="lo-tr__items" role="list">';
    if (list.length > 12) list = list.slice(0, 12).concat([{ name: '', variety: 'and ' + (list.length - 12) + ' more' }]);
    list.forEach(function (p) {
      if (!p) return;
      html += '<li>' + esc(p.name || '') + (p.variety ? ' <span>' + esc(p.variety) + '</span>' : '') + (p.count > 1 ? ' &times; ' + esc(p.count) : '') + '</li>';
    });
    return html + '</ul>';
  }
  function topHtml(info, h, pill, cls) {
    var order = info && info.order_no ? 'Order ' + String(info.order_no).replace(/^#?/, '#') : 'Your order';
    return '<div class="lo-tr__top"><div><p class="lo-tr__order">' + esc(order) + '</p><h3 class="lo-tr__status" tabindex="-1">' + esc(h) + '</h3></div>' +
      (pill ? '<p class="lo-tr__pill' + (cls ? ' lo-tr__pill--' + cls : '') + '">' + esc(pill) + '</p>' : '') + '</div>';
  }
  function railHtml(idx) {
    var html = '<ol class="lo-tr__rail" role="list" aria-label="Delivery progress">';
    STAGES.forEach(function (s, i) {
      html += '<li class="lo-tr__stop' + (i < idx ? ' is-done' : '') + (i === idx ? ' is-now' : '') + '"' + (i === idx ? ' aria-current="step"' : '') + '><span class="lo-tr__dot"></span><span class="lo-tr__lbl">' + s + '</span></li>';
    });
    return html + '</ol>';
  }
  function packsHtml(current) {
    if (packs.length < 2) return '';
    var html = '<div class="lo-tr__packs" role="group" aria-label="Parcels in this order">';
    packs.forEach(function (n, i) {
      if (trackable(n)) html += '<button type="button" class="lo-tr__pack" data-lo-tr-pack="' + esc(n) + '" aria-pressed="' + (n === current ? 'true' : 'false') + '">Parcel ' + (i + 1) + '</button>';
      else html += '<button type="button" class="lo-tr__pack" disabled>Parcel ' + (i + 1) + ', not shipped yet</button>';
    });
    return html + '</div>';
  }
  function setPacks(list, current) {
    var seen = {}, res = [];
    (list || []).forEach(function (n) { if (n && !seen[n]) { seen[n] = 1; res.push(n); } });
    if (res.length > 1) packs = res; else if (packs.indexOf(current) < 0) packs = [];
  }
  function show(html) {
    out.innerHTML = html;
    out.hidden = false;
    var h = out.querySelector('.lo-tr__status');
    if (h) h.focus({ preventScroll: true });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    out.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  }

  function renderTracked(info, shp) {
    var sh = (shp && shp.shipment) || {},
      status = String((sh.latest_status && sh.latest_status.status) || ''),
      metrics = sh.time_metrics || {},
      prov = (sh.tracking && sh.tracking.providers) || [],
      events = [];
    prov.forEach(function (p) { ((p && p.events) || []).forEach(function (e) { if (e && typeof e === 'object') events.push(e); }); });
    var head = headline(status, metrics), html = packsHtml(info && info.no) + topHtml(info, head.h, head.pill, head.cls) + railHtml(stageIndex(status, events));
    if (events.length) {
      html += '<ol class="lo-tr__events" role="list">';
      events.slice(0, 30).forEach(function (e) {
        var w = when(e), text = e.description && !hasCJK(e.description) ? e.description : subLabel(e.sub_status, e.stage),
          place = e.location && !hasCJK(e.location) ? e.location : '';
        html += '<li><span class="lo-tr__when">' + esc(w.d) + (w.t ? ' <span>' + esc(w.t) + '</span>' : '') + '</span><span class="lo-tr__what">' + esc(text) + (place ? '<span>' + esc(place) + '</span>' : '') + '</span></li>';
      });
      html += '</ol>';
    } else if (!status || status === 'InfoReceived' || status.indexOf('NotFound') === 0) {
      html += '<p class="lo-tr__note">The courier has the shipping details and has not scanned the parcel yet. The first scan usually shows within a few days of the shipping email.</p>';
    }
    if (status === 'InTransit' && metrics.days_after_last_update >= 5) {
      html += '<p class="lo-tr__note">No update for ' + esc(metrics.days_after_last_update) + ' days. Parcels can sit quiet while they move between couriers. If that reaches 5 business days, write to ' + mailHtml() + ' with your order number and we will check.</p>';
    }
    if (status && (status.indexOf('DeliveryFailure') === 0 || status.indexOf('Exception') === 0)) {
      html += '<p class="lo-tr__note">Write to ' + mailHtml() + ' with your order number and we will sort it out.</p>';
    }
    html += itemsHtml(info) + '<p class="lo-tr__foot">Tracking number ' + esc(cleanNo(info && info.no)) + '. Updates appear as the courier scans your parcel.</p>';
    show(html);
  }
  function renderPending(info) {
    show(packsHtml(info && info.no) + topHtml(info, 'Not shipped yet', 'Getting ready', 'wait') + railHtml(0) +
      '<p class="lo-tr__note">We have your order and it has not been handed to the courier yet. Orders ship within 1 to 3 business days, and we email you when yours leaves. Ordered longer ago than that? Write to ' + mailHtml() + ' with your order number. A cancelled order also shows here as not shipped: nothing will be sent for it.</p>' + itemsHtml(info));
  }
  function renderUnknown(num) {
    packs = [];
    show('<div class="lo-tr__top"><div><p class="lo-tr__order">Tracking number ' + esc(num) + '</p><h3 class="lo-tr__status" tabindex="-1">We cannot see this number yet</h3></div></div>' +
      '<p class="lo-tr__note">If your shipping email arrived in the last few hours, the courier may not have registered the number yet: try again a little later. Otherwise check the number, look your order up by order number and email, or write to ' + mailHtml() + '.</p>');
  }

  function setBusy(b) {
    busy = b;
    btn.disabled = b;
    btn.textContent = b ? (mode === 'order' ? 'Finding…' : 'Tracking…') : (mode === 'order' ? 'Find my order' : 'Track order');
  }
  function loadEvents(info, my, guid, polls) {
    var item = { num: cleanNo(info.no), fc: info.fc || 0, sc: info.sc || 0 };
    if (info.params) item.params = info.params;
    return post(API_EVENTS, { data: [item], guid: guid || '', g: info.g, lang: 'en', timeZoneOffset: tz() }).then(function (r) {
      if (my !== seq) return;
      var shp = r && r.shipments && r.shipments[0];
      if (shp && shp.code === 100 && polls < 4) {
        return new Promise(function (res) { setTimeout(res, 1500); }).then(function () {
          if (my === seq) return loadEvents(info, my, r.guid || guid, polls + 1);
        });
      }
      setBusy(false);
      renderTracked(info, shp && shp.shipment ? shp : { shipment: { latest_status: { status: 'InfoReceived' } } });
    });
  }
  function handle(r, my, typed, byOrder) {
    if (my !== seq) return;
    if (!r || r.Code !== 0) throw new Error('api');
    var j = r.Json || {}, info = j.info || {};
    if (byOrder && !info.order_no && !info.no) {
      setBusy(false);
      showErr('We could not match that order number and email. Check both against your order confirmation email' + contactTail());
      input.focus();
      return;
    }
    setPacks(j.no_list, info.no || typed);
    if (!trackable(info.no) || !info.g) {
      setBusy(false);
      if (info.order_no) renderPending(info); else renderUnknown(typed);
      return;
    }
    if (!info.fc) { setBusy(false); renderTracked(info, { shipment: { latest_status: { status: 'InfoReceived' } } }); return; }
    return loadEvents(info, my, '', 0);
  }
  function run(fn, attempt, my) {
    setBusy(true);
    fn(my).catch(function () {
      if (my !== seq) return;
      if (attempt < 2) { setTimeout(function () { if (my === seq) run(fn, attempt + 1, my); }, 1400); return; }
      setBusy(false);
      showErr('Tracking is unavailable right now. Please try again in a moment' + contactTail());
      input.focus();
    });
  }
  function byNumber(num) {
    run(function (my) {
      return call('get-track-record-by-track-no', { shop: SHOP, track_no: num }).then(function (r) { return handle(r, my, num, false); });
    }, 1, ++seq);
  }
  function byOrder(order, mail) {
    packs = [];
    run(function (my) {
      return call('get-track-record-by-order-no', { shop: SHOP, type: 'order', order_no: order, user_email: mail }).then(function (r) { return handle(r, my, order, true); });
    }, 1, ++seq);
  }

  function setMode(m) {
    mode = m;
    var order = m === 'order';
    label.textContent = order ? 'Order number' : 'Tracking number';
    input.setAttribute('placeholder', order ? 'For example 1042' : 'From your shipping email');
    input.setAttribute('autocomplete', 'off');
    if (order) input.setAttribute('inputmode', 'numeric'); else input.removeAttribute('inputmode');
    emailRow.hidden = !order;
    form.setAttribute('data-mode', m);
    swap.textContent = order ? 'Have a tracking number? Use it instead' : 'No tracking number? Use your order number and email';
    if (!busy) btn.textContent = order ? 'Find my order' : 'Track order';
    clearErr();
  }
  swap.addEventListener('click', function () { setMode(mode === 'order' ? 'num' : 'order'); input.focus(); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    var v = (input.value || '').trim();
    if (!v) { showErr(mode === 'order' ? 'Enter your order number. It is in your order confirmation email.' : 'Enter the tracking number from your shipping email.'); input.focus(); return; }
    if (mode === 'num' && /^#?\d{1,6}$/.test(v)) { setMode('order'); input.value = v; showErr('That looks like an order number. Add the email you used at checkout.'); email.focus(); return; }
    if (mode === 'order') {
      var em = (email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { showErr('Enter the email address you used at checkout.'); email.focus(); return; }
      clearErr();
      byOrder(v.replace(/^#/, ''), em);
      return;
    }
    clearErr();
    packs = [];
    byNumber(v.replace(/\s+/g, '').toUpperCase());
  });
  out.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lo-tr-pack]');
    if (b && !busy) byNumber(b.getAttribute('data-lo-tr-pack'));
  });
  setMode('order');
  // ссылка вида /pages/track-order?number=XX или ?order=1042&email=a@b.c заполняет форму и ищет сразу.
  // Параметры сразу убираем из адреса: почта в адресе уходила бы в аналитику и в Referer.
  try {
    var q = new URLSearchParams(location.search), qn = (q.get('number') || '').trim(), qo = (q.get('order') || '').trim(), qe = (q.get('email') || '').trim();
    if ((qn || qo) && window.history && history.replaceState) history.replaceState(null, '', location.pathname);
    if (qn && /^#?\d{1,6}$/.test(qn)) { qo = qn; qn = ''; }
    if (qn) { setMode('num'); input.value = qn; byNumber(qn.replace(/\s+/g, '').toUpperCase()); }
    else if (qo) {
      input.value = qo;
      if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(qe)) { email.value = qe; byOrder(qo.replace(/^#/, ''), qe); }
      else { showErr('Add the email you used at checkout.'); email.focus(); }
    }
  } catch (e) {}
})();
